// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.highlightcontrol {
   border-left: #2ea1f8 5px solid !important;
}

.borderdropdown {
   border-left: #2ea1f8 5px solid !important;
   border-radius: 6.5px !important;
   white-space: nowrap;
}

.infoicon {
   margin-left: 10px;
   color: #767676 !important;
   cursor: pointer;
}

.infoicon:hover {
   color: #2c77e8 !important;
}

::ng-deep .cablesize-summary .ng-select .ng-select-container {
   color: #000 !important;
}

.logo {
   height: auto !important;
   width: 225px;
}

.logoArea {
   position: relative;
   width: 225px;
   margin-top: 30px;
}

@media (max-width: 1024px) {
   .logoArea {
      width: auto;
   }

   .logo {
      width: auto;
   }
}

.logoArea .removeImg {
   position: absolute;
   right: 0;
   bottom: 100%;
}

.clsDiplayInlineBlock {
   display: inline-block;
}

.marginleft15 {
   margin-left: 15px;
}

.width100p {
   width: 100%;
}

.ufilename {
   margin-right: 5px;
   padding: 5px;
}

.fupdiv {
   margin-top: 5px;
   margin-left: 1px;
}

.canceltimg {
   background-image: url('32px_new.0bf3478e1251da19.png');
   background-position: -32px -68px;
   width: 26px;
   height: 25px;
}

.uploadimg {
   background-image: url('32px_new.0bf3478e1251da19.png');
   background-position: -260px -6px;
   width: 25px;
   height: 22px;
}

::ng-deep mark {
   background-color: #ffeb3b;
   color: #000;
   font-weight: bold;
   padding: 0;
   border-radius: 3px;
   /* Smooth corners */
}

.search-container .form-control {
   padding-left: 2.375rem;
   width: 100%;
}

.input-search {
   position: absolute;
   top: 47%;
   left: 25px;
   transform: translateY(-50%);
   z-index: 99;
}

.input-search .fa-search {
   width: 16px;
   height: 16px;
}

.input-loader {
   position: absolute;
   top: 47%;
   right: 50px;
   transform: translateY(-50%);
}

.spinner {
   border: 2px solid #ccc;
   border-top: 2px solid #777;
   border-radius: 50%;
   width: 16px;
   height: 16px;
   animation: spin 1s linear infinite;
}

/* Spinner animation */
@keyframes spin {
   0% {
      transform: rotate(0deg);
   }

   100% {
      transform: rotate(360deg);
   }
}

.custom-dropdown {
   width: 100%;
   max-height: 300px;
   overflow-y: auto;
   background-color: white;
   border: 1px solid #ccc;
   border-radius: 0 0 4px 4px;
   box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
   z-index: 1000;
   margin-top: -1px;
   position: absolute;
}

.dropdown-list {
   list-style: none;
   /* Remove default list styling */
   padding: 0;
   margin: 0;
}

.dropdown-loading {
   padding: 8px 10px;
   text-align: center;
   color: #999;
   font-style: italic;
   position: sticky;
   bottom: 0;
}

.dropdown-item-search {
   cursor: pointer;
   transition: background-color 0.2s;
   border-top: 1px solid #e6eaee !important;
   font-weight: 500 !important;
   font-family:
      Source Sans Pro,
      sans-serif !important;
   padding: 5px 0px !important;
   font-size: 14px !important;
   line-height: 21px !important;
}

.dropdown-item-search .col-6 {
   margin: 2px 0;
}

.dropdown-item-search:hover {
   background-color: #f0f0f0;
   /* Highlight on hover */
}

.item-details span {
   white-space: normal;
   overflow: hidden;
   text-overflow: ellipsis;
}

.item-details {
   font-size: 14px;
   /* Set font size for item details */
}

::ng-deep .ngx-slider .ngx-slider-bubble {
   display: none !important;
   /* padding: 1px 7px !important; */
}

::ng-deep .showmin .ngx-slider-bubble {
   display: block !important;
   font-size: 13px !important;
}

::ng-deep .ngx-slider .ngx-slider-span .ngx-slider-bubble {
   font-size: 14px !important;
}

::ng-deep .ngx-slider .ngx-slider-span {
   white-space: nowrap !important;
}

::ng-deep .ngx-slider .ngx-slider-tick-legend {
   top: -30px !important;
   font-size: 14px;
   /* padding-left: 6.4px; */
}

::ng-deep .deviceToConfigure .select2-container--default .select2-selection--single .select2-selection__rendered {
   padding: 0.85rem 2.15rem;
}

::ng-deep .deviceToConfigure .select2-container {
   width: 236.35px !important;
}

/* ::ng-deep 
.ngx-slider .ngx-slider-tick .ngx-slider-tick-legend {

width: 100% !important;

-webkit-transform: translate(0%,0) !important;
transform: translate(0%,0) !important; 
max-width: 100%  !important; 
left: 0 !important;
} */

::ng-deep #timedelay-rangediv .classtype .ngx-slider-tick .ngx-slider-tick-legend {
   top: -30px !important;
   width: 50px !important;
   display: block !important;
   max-width: 50px !important;

   /* margin-left: -25px; */
}

::ng-deep .excesselements .ngx-slider-ticks .ngx-slider-tick span.ngx-slider-tick-legend {
   visibility: hidden;
}

::ng-deep .excesselements .ngx-slider-ticks .ngx-slider-tick:first-child .ngx-slider-tick-legend {
   visibility: visible;
}

::ng-deep .excesselements .ngx-slider-ticks .ngx-slider-tick:last-child .ngx-slider-tick-legend {
   visibility: visible;
}

::ng-deep .ngx-slider .ngx-slider-pointer {
   transform: scale(0.6) !important;
}

::ng-deep .ngx-slider.animate .ngx-slider-bubble {
   font-size: 14px !important;
}

::ng-deep .ngx-slider span.ngx-slider-span.ngx-slider-bubble.ngx-slider-model-value {
   padding: 1px 1px 1px 12px !important;
}

::ng-deep .cablesize-summary .ng-select .ng-select-container {
   color: #000 !important;
}

.dropdown-header {
   position: sticky;
   top: 0;
   background-color: #f1f1f1;
   padding: 8px 10px;
   font-weight: bold;
   color: #666;
   border-bottom: 1px solid #ddd;
   z-index: 1;
   text-align: right;
}

.search-tooltip {
   display: flex;
   align-items: center;
   padding-left: 0px;
}

.loading {
   position: fixed;
   z-index: 999;
   height: 2em;
   width: 2em;
   overflow: show;
   margin: auto;
   top: 40px;
   left: 0;
   right: 0;
}

.loading:not(:required) {
   font: 0 / 0 a;
   color: transparent;
   text-shadow: none;
   background-color: transparent;
   border: 0;
}

.c-choice__input + .c-choice__label::before {
   left: 0;
}

.c-choice__input + .c-choice__label {
   gap: 5px !important;
}

.scroll-box {
   overflow-y: auto;
}

@media screen and (max-width: 1500px) {
   .scroll-box {
      height: auto !important;
      padding-bottom: 0 !important;
      min-height: 220px;
   }
}

.status-bar {
   padding: 10px;
   border-radius: 4px;
   font-weight: 400;
   font-family: "Source Sans Pro", sans-serif;
   display: flex;
   align-items: center;
   justify-content: space-between;
   min-height: 55.6px;   
}

.status-bar span{
   font-size: 16px;
}

.status-bar.green {
   background-color: #e0f3e0;
   color: #2f8a2f;
}

.status-bar.red {
   background-color: #fce0e0;
   color: #d11a2a;
}

.status-bar.yellow {
   background-color: #fff3cd;
   color: #856404;
}

.status-btn {
   color: #d11a2a !important;
   cursor: pointer;
   padding: 0.5rem 0.5rem !important;
}

hr {
   width: 100%;
   margin: 10px 0;
}

.clscontainer {
   font-family: "Source Sans Pro", sans-serif;
}

.detail-section .form-group {
   margin: 0.05rem;
}

.detail-heading b {
   font-size: 16px;
   margin-bottom: 10px;
}

.detail-table-box {
   margin-top: 15px;
}

.cc-curveelements tr th {
   white-space: nowrap;
   background-color: #ebedf2;
   padding-top: 3px;
   padding-bottom: 3px;
   border-color: #9aa0a9;
}

.cc-curveelements tr.table-border {
   border-color: #9aa0a9 !important;
}

.cc-curveelements tr:nth-child(even) {
   background: #f4f3fb;
}

.cc-curveelements tr td {
   padding: 1px 0.75rem;
   vertical-align: middle;
}

@media only screen and (min-width: 1px) and (max-width: 400px) {
   .myDiv-Graph {
      height: 400px;
   }

   .btnSelectProtection {
      width: 75px;
   }

   .btnReportsProtection {
      width: 75px;
   }

   .btnErrorProtection {
      width: 90px;
   }
}

@media only screen and (min-width: 401px) and (max-width: 700px) {
   .myDiv-Graph {
      height: 500px;
   }

   .btnSelectProtection {
      width: 85px;
   }

   .btnReportsProtection {
      width: 85px;
   }
}

@media only screen and (min-width: 701px) and (max-width: 991px) {
   .myDiv-Graph {
      height: 550px;
   }
}

@media (min-width: 992px) {
   .myDiv-Graph {
      height: 687px;
   }   
}

@media (max-width: 992px) {
   .scroll-box.scroll-box-cable-size {
      padding-bottom: 15px !important;
   }
}

::ng-deep g.g-gtitle {
   display: none !important;
}

div .card-body {
   min-width: 50px !important;
}

::ng-deep .ytitle {
   fill: #212529 !important;
}

::ng-deep .xtitle {
   fill: #212529 !important;
}

::ng-deep .legendtext .line {
   fill: #212529 !important;
}

.use-wiz-label::before{
   left: -5px !important;
}`, "",{"version":3,"sources":["webpack://./src/app/main/cablepro/Network/iec-cablesize/iec-cablesize.component.css"],"names":[],"mappings":"AAAA;GACG,yCAAyC;AAC5C;;AAEA;GACG,yCAAyC;GACzC,+BAA+B;GAC/B,mBAAmB;AACtB;;AAEA;GACG,iBAAiB;GACjB,yBAAyB;GACzB,eAAe;AAClB;;AAEA;GACG,yBAAyB;AAC5B;;AAEA;GACG,sBAAsB;AACzB;;AAEA;GACG,uBAAuB;GACvB,YAAY;AACf;;AAEA;GACG,kBAAkB;GAClB,YAAY;GACZ,gBAAgB;AACnB;;AAEA;GACG;MACG,WAAW;GACd;;GAEA;MACG,WAAW;GACd;AACH;;AAEA;GACG,kBAAkB;GAClB,QAAQ;GACR,YAAY;AACf;;AAEA;GACG,qBAAqB;AACxB;;AAEA;GACG,iBAAiB;AACpB;;AAEA;GACG,WAAW;AACd;;AAEA;GACG,iBAAiB;GACjB,YAAY;AACf;;AAEA;GACG,eAAe;GACf,gBAAgB;AACnB;;AAEA;GACG,sDAA0D;GAC1D,gCAAgC;GAChC,WAAW;GACX,YAAY;AACf;;AAEA;GACG,sDAA0D;GAC1D,gCAAgC;GAChC,WAAW;GACX,YAAY;AACf;;AAEA;GACG,yBAAyB;GACzB,WAAW;GACX,iBAAiB;GACjB,UAAU;GACV,kBAAkB;GAClB,mBAAmB;AACtB;;AAEA;GACG,sBAAsB;GACtB,WAAW;AACd;;AAEA;GACG,kBAAkB;GAClB,QAAQ;GACR,UAAU;GACV,2BAA2B;GAC3B,WAAW;AACd;;AAEA;GACG,WAAW;GACX,YAAY;AACf;;AAEA;GACG,kBAAkB;GAClB,QAAQ;GACR,WAAW;GACX,2BAA2B;AAC9B;;AAEA;GACG,sBAAsB;GACtB,0BAA0B;GAC1B,kBAAkB;GAClB,WAAW;GACX,YAAY;GACZ,kCAAkC;AACrC;;AAEA,sBAAsB;AACtB;GACG;MACG,uBAAuB;GAC1B;;GAEA;MACG,yBAAyB;GAC5B;AACH;;AAEA;GACG,WAAW;GACX,iBAAiB;GACjB,gBAAgB;GAChB,uBAAuB;GACvB,sBAAsB;GACtB,0BAA0B;GAC1B,wCAAwC;GACxC,aAAa;GACb,gBAAgB;GAChB,kBAAkB;AACrB;;AAEA;GACG,gBAAgB;GAChB,gCAAgC;GAChC,UAAU;GACV,SAAS;AACZ;;AAEA;GACG,iBAAiB;GACjB,kBAAkB;GAClB,WAAW;GACX,kBAAkB;GAClB,gBAAgB;GAChB,SAAS;AACZ;;AAEA;GACG,eAAe;GACf,iCAAiC;GACjC,wCAAwC;GACxC,2BAA2B;GAC3B;;2BAEwB;GACxB,2BAA2B;GAC3B,0BAA0B;GAC1B,4BAA4B;AAC/B;;AAEA;GACG,aAAa;AAChB;;AAEA;GACG,yBAAyB;GACzB,uBAAuB;AAC1B;;AAEA;GACG,mBAAmB;GACnB,gBAAgB;GAChB,uBAAuB;AAC1B;;AAEA;GACG,eAAe;GACf,mCAAmC;AACtC;;AAEA;GACG,wBAAwB;GACxB,iCAAiC;AACpC;;AAEA;GACG,yBAAyB;GACzB,0BAA0B;AAC7B;;AAEA;GACG,0BAA0B;AAC7B;;AAEA;GACG,8BAA8B;AACjC;;AAEA;GACG,qBAAqB;GACrB,eAAe;GACf,yBAAyB;AAC5B;;AAEA;GACG,wBAAwB;AAC3B;;AAEA;GACG,0BAA0B;AAC7B;;AAEA;;;;;;;;;GASG;;AAEH;GACG,qBAAqB;GACrB,sBAAsB;GACtB,yBAAyB;GACzB,0BAA0B;;GAE1B,wBAAwB;AAC3B;;AAEA;GACG,kBAAkB;AACrB;;AAEA;GACG,mBAAmB;AACtB;;AAEA;GACG,mBAAmB;AACtB;;AAEA;GACG,gCAAgC;AACnC;;AAEA;GACG,0BAA0B;AAC7B;;AAEA;GACG,oCAAoC;AACvC;;AAEA;GACG,sBAAsB;AACzB;;AAEA;GACG,gBAAgB;GAChB,MAAM;GACN,yBAAyB;GACzB,iBAAiB;GACjB,iBAAiB;GACjB,WAAW;GACX,6BAA6B;GAC7B,UAAU;GACV,iBAAiB;AACpB;;AAEA;GACG,aAAa;GACb,mBAAmB;GACnB,iBAAiB;AACpB;;AAEA;GACG,eAAe;GACf,YAAY;GACZ,WAAW;GACX,UAAU;GACV,cAAc;GACd,YAAY;GACZ,SAAS;GACT,OAAO;GACP,QAAQ;AACX;;AAEA;GACG,aAAa;GACb,kBAAkB;GAClB,iBAAiB;GACjB,6BAA6B;GAC7B,SAAS;AACZ;;AAEA;GACG,OAAO;AACV;;AAEA;GACG,mBAAmB;AACtB;;AAEA;GACG,gBAAgB;AACnB;;AAEA;GACG;MACG,uBAAuB;MACvB,4BAA4B;MAC5B,iBAAiB;GACpB;AACH;;AAEA;GACG,aAAa;GACb,kBAAkB;GAClB,gBAAgB;GAChB,0CAA0C;GAC1C,aAAa;GACb,mBAAmB;GACnB,8BAA8B;GAC9B,kBAAkB;AACrB;;AAEA;GACG,eAAe;AAClB;;AAEA;GACG,yBAAyB;GACzB,cAAc;AACjB;;AAEA;GACG,yBAAyB;GACzB,cAAc;AACjB;;AAEA;GACG,yBAAyB;GACzB,cAAc;AACjB;;AAEA;GACG,yBAAyB;GACzB,eAAe;GACf,iCAAiC;AACpC;;AAEA;GACG,WAAW;GACX,cAAc;AACjB;;AAEA;GACG,0CAA0C;AAC7C;;AAEA;GACG,eAAe;AAClB;;AAEA;GACG,eAAe;GACf,mBAAmB;AACtB;;AAEA;GACG,gBAAgB;AACnB;;AAEA;GACG,mBAAmB;GACnB,yBAAyB;GACzB,gBAAgB;GAChB,mBAAmB;GACnB,qBAAqB;AACxB;;AAEA;GACG,gCAAgC;AACnC;;AAEA;GACG,mBAAmB;AACtB;;AAEA;GACG,oBAAoB;GACpB,sBAAsB;AACzB;;AAEA;GACG;MACG,aAAa;GAChB;;GAEA;MACG,WAAW;GACd;;GAEA;MACG,WAAW;GACd;;GAEA;MACG,WAAW;GACd;AACH;;AAEA;GACG;MACG,aAAa;GAChB;;GAEA;MACG,WAAW;GACd;;GAEA;MACG,WAAW;GACd;AACH;;AAEA;GACG;MACG,aAAa;GAChB;AACH;;AAEA;GACG;MACG,aAAa;GAChB;AACH;;AAEA;GACG;MACG,+BAA+B;GAClC;AACH;;AAEA;GACG,wBAAwB;AAC3B;;AAEA;GACG,0BAA0B;AAC7B;;AAEA;GACG,wBAAwB;AAC3B;;AAEA;GACG,wBAAwB;AAC3B;;AAEA;GACG,wBAAwB;AAC3B;;AAEA;GACG,qBAAqB;AACxB","sourcesContent":[".highlightcontrol {\n   border-left: #2ea1f8 5px solid !important;\n}\n\n.borderdropdown {\n   border-left: #2ea1f8 5px solid !important;\n   border-radius: 6.5px !important;\n   white-space: nowrap;\n}\n\n.infoicon {\n   margin-left: 10px;\n   color: #767676 !important;\n   cursor: pointer;\n}\n\n.infoicon:hover {\n   color: #2c77e8 !important;\n}\n\n::ng-deep .cablesize-summary .ng-select .ng-select-container {\n   color: #000 !important;\n}\n\n.logo {\n   height: auto !important;\n   width: 225px;\n}\n\n.logoArea {\n   position: relative;\n   width: 225px;\n   margin-top: 30px;\n}\n\n@media (max-width: 1024px) {\n   .logoArea {\n      width: auto;\n   }\n\n   .logo {\n      width: auto;\n   }\n}\n\n.logoArea .removeImg {\n   position: absolute;\n   right: 0;\n   bottom: 100%;\n}\n\n.clsDiplayInlineBlock {\n   display: inline-block;\n}\n\n.marginleft15 {\n   margin-left: 15px;\n}\n\n.width100p {\n   width: 100%;\n}\n\n.ufilename {\n   margin-right: 5px;\n   padding: 5px;\n}\n\n.fupdiv {\n   margin-top: 5px;\n   margin-left: 1px;\n}\n\n.canceltimg {\n   background-image: url(\"assets/common/images/32px_new.png\");\n   background-position: -32px -68px;\n   width: 26px;\n   height: 25px;\n}\n\n.uploadimg {\n   background-image: url(\"assets/common/images/32px_new.png\");\n   background-position: -260px -6px;\n   width: 25px;\n   height: 22px;\n}\n\n::ng-deep mark {\n   background-color: #ffeb3b;\n   color: #000;\n   font-weight: bold;\n   padding: 0;\n   border-radius: 3px;\n   /* Smooth corners */\n}\n\n.search-container .form-control {\n   padding-left: 2.375rem;\n   width: 100%;\n}\n\n.input-search {\n   position: absolute;\n   top: 47%;\n   left: 25px;\n   transform: translateY(-50%);\n   z-index: 99;\n}\n\n.input-search .fa-search {\n   width: 16px;\n   height: 16px;\n}\n\n.input-loader {\n   position: absolute;\n   top: 47%;\n   right: 50px;\n   transform: translateY(-50%);\n}\n\n.spinner {\n   border: 2px solid #ccc;\n   border-top: 2px solid #777;\n   border-radius: 50%;\n   width: 16px;\n   height: 16px;\n   animation: spin 1s linear infinite;\n}\n\n/* Spinner animation */\n@keyframes spin {\n   0% {\n      transform: rotate(0deg);\n   }\n\n   100% {\n      transform: rotate(360deg);\n   }\n}\n\n.custom-dropdown {\n   width: 100%;\n   max-height: 300px;\n   overflow-y: auto;\n   background-color: white;\n   border: 1px solid #ccc;\n   border-radius: 0 0 4px 4px;\n   box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);\n   z-index: 1000;\n   margin-top: -1px;\n   position: absolute;\n}\n\n.dropdown-list {\n   list-style: none;\n   /* Remove default list styling */\n   padding: 0;\n   margin: 0;\n}\n\n.dropdown-loading {\n   padding: 8px 10px;\n   text-align: center;\n   color: #999;\n   font-style: italic;\n   position: sticky;\n   bottom: 0;\n}\n\n.dropdown-item-search {\n   cursor: pointer;\n   transition: background-color 0.2s;\n   border-top: 1px solid #e6eaee !important;\n   font-weight: 500 !important;\n   font-family:\n      Source Sans Pro,\n      sans-serif !important;\n   padding: 5px 0px !important;\n   font-size: 14px !important;\n   line-height: 21px !important;\n}\n\n.dropdown-item-search .col-6 {\n   margin: 2px 0;\n}\n\n.dropdown-item-search:hover {\n   background-color: #f0f0f0;\n   /* Highlight on hover */\n}\n\n.item-details span {\n   white-space: normal;\n   overflow: hidden;\n   text-overflow: ellipsis;\n}\n\n.item-details {\n   font-size: 14px;\n   /* Set font size for item details */\n}\n\n::ng-deep .ngx-slider .ngx-slider-bubble {\n   display: none !important;\n   /* padding: 1px 7px !important; */\n}\n\n::ng-deep .showmin .ngx-slider-bubble {\n   display: block !important;\n   font-size: 13px !important;\n}\n\n::ng-deep .ngx-slider .ngx-slider-span .ngx-slider-bubble {\n   font-size: 14px !important;\n}\n\n::ng-deep .ngx-slider .ngx-slider-span {\n   white-space: nowrap !important;\n}\n\n::ng-deep .ngx-slider .ngx-slider-tick-legend {\n   top: -30px !important;\n   font-size: 14px;\n   /* padding-left: 6.4px; */\n}\n\n::ng-deep .deviceToConfigure .select2-container--default .select2-selection--single .select2-selection__rendered {\n   padding: 0.85rem 2.15rem;\n}\n\n::ng-deep .deviceToConfigure .select2-container {\n   width: 236.35px !important;\n}\n\n/* ::ng-deep \n.ngx-slider .ngx-slider-tick .ngx-slider-tick-legend {\n\nwidth: 100% !important;\n\n-webkit-transform: translate(0%,0) !important;\ntransform: translate(0%,0) !important; \nmax-width: 100%  !important; \nleft: 0 !important;\n} */\n\n::ng-deep #timedelay-rangediv .classtype .ngx-slider-tick .ngx-slider-tick-legend {\n   top: -30px !important;\n   width: 50px !important;\n   display: block !important;\n   max-width: 50px !important;\n\n   /* margin-left: -25px; */\n}\n\n::ng-deep .excesselements .ngx-slider-ticks .ngx-slider-tick span.ngx-slider-tick-legend {\n   visibility: hidden;\n}\n\n::ng-deep .excesselements .ngx-slider-ticks .ngx-slider-tick:first-child .ngx-slider-tick-legend {\n   visibility: visible;\n}\n\n::ng-deep .excesselements .ngx-slider-ticks .ngx-slider-tick:last-child .ngx-slider-tick-legend {\n   visibility: visible;\n}\n\n::ng-deep .ngx-slider .ngx-slider-pointer {\n   transform: scale(0.6) !important;\n}\n\n::ng-deep .ngx-slider.animate .ngx-slider-bubble {\n   font-size: 14px !important;\n}\n\n::ng-deep .ngx-slider span.ngx-slider-span.ngx-slider-bubble.ngx-slider-model-value {\n   padding: 1px 1px 1px 12px !important;\n}\n\n::ng-deep .cablesize-summary .ng-select .ng-select-container {\n   color: #000 !important;\n}\n\n.dropdown-header {\n   position: sticky;\n   top: 0;\n   background-color: #f1f1f1;\n   padding: 8px 10px;\n   font-weight: bold;\n   color: #666;\n   border-bottom: 1px solid #ddd;\n   z-index: 1;\n   text-align: right;\n}\n\n.search-tooltip {\n   display: flex;\n   align-items: center;\n   padding-left: 0px;\n}\n\n.loading {\n   position: fixed;\n   z-index: 999;\n   height: 2em;\n   width: 2em;\n   overflow: show;\n   margin: auto;\n   top: 40px;\n   left: 0;\n   right: 0;\n}\n\n.loading:not(:required) {\n   font: 0 / 0 a;\n   color: transparent;\n   text-shadow: none;\n   background-color: transparent;\n   border: 0;\n}\n\n.c-choice__input + .c-choice__label::before {\n   left: 0;\n}\n\n.c-choice__input + .c-choice__label {\n   gap: 5px !important;\n}\n\n.scroll-box {\n   overflow-y: auto;\n}\n\n@media screen and (max-width: 1500px) {\n   .scroll-box {\n      height: auto !important;\n      padding-bottom: 0 !important;\n      min-height: 220px;\n   }\n}\n\n.status-bar {\n   padding: 10px;\n   border-radius: 4px;\n   font-weight: 400;\n   font-family: \"Source Sans Pro\", sans-serif;\n   display: flex;\n   align-items: center;\n   justify-content: space-between;\n   min-height: 55.6px;   \n}\n\n.status-bar span{\n   font-size: 16px;\n}\n\n.status-bar.green {\n   background-color: #e0f3e0;\n   color: #2f8a2f;\n}\n\n.status-bar.red {\n   background-color: #fce0e0;\n   color: #d11a2a;\n}\n\n.status-bar.yellow {\n   background-color: #fff3cd;\n   color: #856404;\n}\n\n.status-btn {\n   color: #d11a2a !important;\n   cursor: pointer;\n   padding: 0.5rem 0.5rem !important;\n}\n\nhr {\n   width: 100%;\n   margin: 10px 0;\n}\n\n.clscontainer {\n   font-family: \"Source Sans Pro\", sans-serif;\n}\n\n.detail-section .form-group {\n   margin: 0.05rem;\n}\n\n.detail-heading b {\n   font-size: 16px;\n   margin-bottom: 10px;\n}\n\n.detail-table-box {\n   margin-top: 15px;\n}\n\n.cc-curveelements tr th {\n   white-space: nowrap;\n   background-color: #ebedf2;\n   padding-top: 3px;\n   padding-bottom: 3px;\n   border-color: #9aa0a9;\n}\n\n.cc-curveelements tr.table-border {\n   border-color: #9aa0a9 !important;\n}\n\n.cc-curveelements tr:nth-child(even) {\n   background: #f4f3fb;\n}\n\n.cc-curveelements tr td {\n   padding: 1px 0.75rem;\n   vertical-align: middle;\n}\n\n@media only screen and (min-width: 1px) and (max-width: 400px) {\n   .myDiv-Graph {\n      height: 400px;\n   }\n\n   .btnSelectProtection {\n      width: 75px;\n   }\n\n   .btnReportsProtection {\n      width: 75px;\n   }\n\n   .btnErrorProtection {\n      width: 90px;\n   }\n}\n\n@media only screen and (min-width: 401px) and (max-width: 700px) {\n   .myDiv-Graph {\n      height: 500px;\n   }\n\n   .btnSelectProtection {\n      width: 85px;\n   }\n\n   .btnReportsProtection {\n      width: 85px;\n   }\n}\n\n@media only screen and (min-width: 701px) and (max-width: 991px) {\n   .myDiv-Graph {\n      height: 550px;\n   }\n}\n\n@media (min-width: 992px) {\n   .myDiv-Graph {\n      height: 687px;\n   }   \n}\n\n@media (max-width: 992px) {\n   .scroll-box.scroll-box-cable-size {\n      padding-bottom: 15px !important;\n   }\n}\n\n::ng-deep g.g-gtitle {\n   display: none !important;\n}\n\ndiv .card-body {\n   min-width: 50px !important;\n}\n\n::ng-deep .ytitle {\n   fill: #212529 !important;\n}\n\n::ng-deep .xtitle {\n   fill: #212529 !important;\n}\n\n::ng-deep .legendtext .line {\n   fill: #212529 !important;\n}\n\n.use-wiz-label::before{\n   left: -5px !important;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
